import { render } from "./competence-update-competence.vue?vue&type=template&id=012ea6d6&scoped=true"
import script from "./competence-update-competence.vue?vue&type=script&lang=js"
export * from "./competence-update-competence.vue?vue&type=script&lang=js"

import "./competence-update-competence.vue?vue&type=style&index=0&id=012ea6d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012ea6d6"],['__file',"src/components/applications/competence/update/competence-update-competence.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "012ea6d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('012ea6d6', __exports__)) {
    api.reload('012ea6d6', __exports__)
  }
  
  module.hot.accept("./competence-update-competence.vue?vue&type=template&id=012ea6d6&scoped=true", () => {
    api.rerender('012ea6d6', render)
  })

}


export default __exports__